import { render, staticRenderFns } from "./BannerModalForm.vue?vue&type=template&id=50638971"
import script from "./BannerModalForm.vue?vue&type=script&lang=js"
export * from "./BannerModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports